"use client";
import { InlineWidget } from "react-calendly";

const styles = new Proxy({"BookAMeeting":"BookAMeeting-b7514","Calendly":"Calendly-b7514"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import Section from "../Section";

const BookAMeetingPage = () => (
  <div className={styles.BookAMeeting}>
    <Section title="Schedule a Meeting">
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <InlineWidget
            className={styles.Calendly}
            url="https://calendly.com/tamas-cursor-insight/gait-recognition"
            pageSettings={{
              backgroundColor: "ffffff",
              textColor: "132735",
              primaryColor: "3DBEEC",
              hideGdprBanner: true,
            }}
          />
        </div>
      </div>
    </Section>
  </div>
);

export default BookAMeetingPage;
